import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import OrderForm from './component/orders/OrderForm';
import Login from './component/orders/login/login';
import HomeBackend from './component/HomeBackend';
import OrgDetails from './component/orders/OrgDetails';
import LoadingAnimation from './component/LoadingAnimation';
import PrivateRoute from './component/PrivateRoute'; // Import PrivateRoute
import VerificationForm from './component/orders/VerificationForm';

function App() {
  const authToken = localStorage.getItem('authToken');
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={authToken ? <Navigate to="/home" /> : <Login />} />
        <Route path="/loding" element={<LoadingAnimation />} />
     
        <Route
          path="/orders/:itemId"
          element={
            <PrivateRoute
              element={OrderForm}
            />
          }
        />
        <Route
          path="/orders"
          element={
            <PrivateRoute
              element={OrderForm}
            />
          }
        />
        <Route
          path="/home"
          element={
            <PrivateRoute
              element={HomeBackend}
            />
          }
        />
        <Route
          path="/verification-form/:itemId"
          element={
            <PrivateRoute
              element={VerificationForm}
            />
          }
        />
        <Route
          path="/org-details"
          element={<PrivateRoute element={OrgDetails} />}
        />
      </Routes>
    </div>
  );
}

export default App;
